export { default as useWLCData } from './useWLCData';
